import { Col, Container, Row, Stack } from "react-bootstrap";
import classes from "./styles.module.scss";
import { Heading } from "@/ui/Heading";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import clsx from "classnames";
import { offices_helper } from "@/helpers/offices_helper";
import Image from "@/ui/Image";
import slug from "slug";
import ArrowRight from "@/assets/ArrowRight.svg";

export const CulturePageOfficesSection = ({ className }) => {
  const locale = useLocale();
  const offices = offices_helper.fetch();
  const regions = offices_helper.regions();

  return (
    <div className={clsx(className, classes.offices)}>
      <Container>
        <Heading className="mb-4 mb-md-5" variant="quaternary">
          <DynamicText path={`page.culture.offices.title.${locale}`} tag="h2" />
        </Heading>
        <Row>
          {regions.map((i, k) => (
            <Col xs={12} md={4} key={k} className="mb-3 mb-md-0">
              <div className={classes.offices__region}>
                <Image
                  img={{ path: `page.culture.offices.${slug(i)}.bg`, src: `/assets/culture/offices/${slug(i)}/1.jpg` }}
                  size="449x513"
                  alt=""
                />
                <div className={clsx(classes.offices__region__content, "p-4")}>
                  <h3 className="mb-4">{i}</h3>
                  <ul>
                    {offices
                      .filter((o) => o.region === i)
                      .map((o) => (
                        <li key={o.id} className="mb-1">
                          <a href={o.url}>
                            {o.title} <ArrowRight />
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

CulturePageOfficesSection.defaultProps = {
  className: "py-4 py-md-5",
};
